@if (localizationService.currentLocale$ | async; as locale) {
  <div class="add-to-cart-popup">
    <div class="container">
      @if ((checkoutService.outOfStockProductsPopup$ | async); as outOfStock) {
        @if (outOfStock?.length) {
          <div class="header">
            <h3>
              {{ 'products.could-not-be-added-cart' | translate }}
            </h3>
            <span class="close-icon"
              appIcon="close"
              (click)="closeDialog()"
            ></span>
          </div>
          <div>
            @for (line of outOfStock; track line) {
              <div class="product">
                <img class="product-image"
                  loading="lazy"
                  [src]="line.primaryImage | imageSize : 240"
                  [alt]="line.name"
                  />
                <div class="product-information">
                  <p class="product-brand stretch">
                    {{ line.brand }}
                  </p>
                  <p class="product-type stretch first-letter-uppercase">
                    {{ line.name }}
                  </p>
                  <div class="line-flex">
                    @if (authService.user$ | async; as user) {
                      @if (! user.hidePurchasePrice) {
                        @if (line.debtorPrice) {
                          <p
                            class="product-price"
                            >
                            € {{ line.debtorPrice | priceSplit }}
                          </p>
                        }
                      }
                    }
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="actions">
            <app-button theme="line"
              layout="label-only"
              (clicked)="addToWishlist()"
              >
              {{ 'products.add-to-wishlist-instead' | translate }}
            </app-button>
          </div>
          <hr class="hr">
        }
      }
      @if ((shoppingCartWithAddedEansFiltered$ | async); as shoppingCartWithAddedEansFiltered) {
        @if (shoppingCartWithAddedEansFiltered.length) {
          <div class="header">
            <h3>
              {{ 'added-to-shopping-cart.added-to-your-cart' | translate }}
            </h3>
            <span class="close-icon"
              appIcon="close"
              (click)="closeDialog()"
            ></span>
          </div>
          @for (line of shoppingCartWithAddedEansFiltered; track line) {
            @if (line) {
              <div
                class="product"
                >
                @if (line.product.images | getProductImageOfType: ProductImageTypeEnum.Front; as productImage) {
                  <img class="product-image"
                    loading="lazy"
                    [src]="productImage.url | imageSize : 240"
                    [alt]="productImage.alt"
                    />
                }
                <div class="product-information">
                  <p class="product-brand stretch">
                    {{ line.product.brand?.name ?? '' }}
                  </p>
                  <p class="product-type stretch first-letter-uppercase">
                    {{ line.product.translations[locale].name }}
                  </p>
                  <div class="line-flex">
                    <p class="product-amount">
                      {{ line.addedQuantity}}  x
                    </p>
                    @if (authService.user$ | async; as user) {
                      @if (! user.hidePurchasePrice) {
                        @if (line.price) {
                          <p
                            class="product-price"
                            >
                            € {{ line.price | priceSplit }}
                          </p>
                        }
                      }
                    }
                  </div>
                </div>
              </div>
            }
          }
          <div class="actions">
            <app-button theme="dark"
              type="link"
              [link]="'/shopping-cart' | translateRoute"
              (clicked)="closeDialog()"
              >
              {{ 'added-to-shopping-cart.view-your-cart' | translate }}
            </app-button>
            <app-button theme="line"
              (clicked)="closeDialog()"
              >
              {{ 'added-to-shopping-cart.continue-shopping' | translate }}
            </app-button>
          </div>
        }
      }
    </div>
  </div>
}
